import { useQuery } from '@tanstack/react-query';
import { SearchService } from '../SearchService';

export const useSearchResults = ({ email, contact, name, pageNo, pageSize }) =>
  useQuery({
    queryKey: ['search', 'results', email, contact, name, pageNo, pageSize],
    queryFn: () =>
      SearchService.getSearchResults({
        email,
        contact,
        name,
        pageNo,
        pageSize,
      }),
    enabled: !!(email || contact || name), // Only run search if at least one search parameter is provided
  });

export const useCandidateSuggest = ({ name, limit = 10 }) =>
  useQuery({
    queryKey: ['search', 'suggest', name],
    queryFn: () => SearchService.suggestCandidates({ name, limit }),
    enabled: typeof name === 'string' && name.trim().length >= 2,
  });

export const useCandidateDetails = (id) =>
  useQuery({
    queryKey: ['search', 'candidate-details', id],
    queryFn: () => SearchService.getCandidateDetails(id),
    enabled: !!id,
  });
